import styled from 'styled-components'

const Heading = styled.div`
  color: ${props => props.theme.color.palette['brand-1']};
`
const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: ${props => props.theme.size.breakpoint['max-width'].xs}) {
    flex-direction: column;
  }
`

const EnergyContentWrapper = styled.div`
  margin: 20px;
`
export { Heading, Wrapper, EnergyContentWrapper }
